import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_ds_find_reason_codesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { parentIds?: number[], fullTextSearch?: string, ids?: number[] }): 
  Promise<{ result: { Id?: number, Label?: string, LookupCode?: string, Name?: string, ParentEntity?: string, ParentId?: number }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { parentIds?: number[], fullTextSearch?: string, ids?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Label?: string, LookupCode?: string, Name?: string, ParentEntity?: string, ParentId?: number }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { parentIds?: number[], fullTextSearch?: string, ids?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, Label?: string, LookupCode?: string, Name?: string, ParentEntity?: string, ParentId?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      parentIds?: number[], fullTextSearch?: string, ids?: number[]    }) {
      return false;
    }
}
